<template>
  <v-container fluid class="extranet">
    <h1>REVUES</h1>
    <p class="red--text font-italic">
      *Toute distribution, diffusion et/ou reproduction totale ou partielle est interdite sans l’autorisation écrite préalable de Diabète Québec.
    </p>
    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      :label="$t('revuesPleinSoleil.searchLabel')"
      single-line
      hide-details
      class="pb-6"
    ></v-text-field>
    <v-data-table
      :headers="headers"
      :items="revues"
      :search="search"
      sort-by="dateParution"
      sort-desc
      class="extranet-list"
    >
      <template v-slot:item.dateParution="{ item }">
        <span>{{ new Date(item.dateParution).toLocaleDateString() }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon @click="openRevuePleinSoleil(item)">
          mdi-book-open-variant
        </v-icon>
      </template>
      <template v-slot:item.flipMode="{ item }">
        <v-icon @click="openRevuePleinSoleilFlipMode(item)">
          mdi-book-open-variant
        </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import Auth from "@/mixins/Auth"
import WithExtranetXToken from "@/mixins/WithExtranetXToken"
import { Api } from "@/plugins/api"

export default {
  name: "RevuesPleinSoleil",
  mixins: [Auth, WithExtranetXToken],
  data() {
    return {
      search: "",
      revues: [],
      headers: [],
    }
  },
  async mounted() {
    this.$i18n.locale = this.$route.query.lang || "fr"
    const loggedIn = await this.authWithToken()
    if (loggedIn) {
      Api.get("revues-plein-soleil?token=" + this.encodedToken).then((res) => {
        this.revues = res.data
        this.headers = [
          {
            text: this.$t("revuesPleinSoleil.titreRevue"),
            filterable: true,
            value: "titreRevue",
          },
          {
            text: this.$t("revuesPleinSoleil.dateParution"),
            value: "dateParution",
            filterable: true,
          },
          {
            text: this.$t("revuesPleinSoleil.urlModePdf"),
            value: "actions",
            sortable: false,
            width: "20px",
          },
          {
            text: this.$t("revuesPleinSoleil.urlModeFlip"),
            value: "flipMode",
            sortable: false,
            width: "20px",
          },
        ]
      })
    }
  },
  methods: {
    openRevuePleinSoleil(item) {
      window.open(item.lienRevue)
    },
    openRevuePleinSoleilFlipMode(item) {
      window.open(item.urlModeFlip)
    },
    extranetRowStyle() {
      return "extranet-row-style"
    },
  },
}
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Work%20Sans&display=swap");

.extranet {
  height: 100%;
  padding: 24px;
  font-family: "Work Sans";
  font-size: 16px !important;
  background-color: #f3f3f3;
}

.extranet-list {
  background-color: #e2e2e2 !important;
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.05);
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row),
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > th:not(.v-data-table__mobile-row) {
  border-bottom: none;
}

.theme--light.v-data-table .v-data-footer {
  border-top: none;
}

.v-data-table > .v-data-table__wrapper > table > tbody > tr > th,
.v-data-table > .v-data-table__wrapper > table > thead > tr > th,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > th,
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-footer {
  font-size: 16px !important;
}

tbody {
  tr:hover {
    background-color: transparent !important;
  }
}
</style>
